var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spaces container",
    attrs: {
      "id": "million-bit-spaces"
    }
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Based Spaces")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Twitter X Base spaces that are hosted by members of the MBH community.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Coming up " + _vm._s(_vm.nextPast === 'next' ? 'next' : 'past') + " "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.togglePastNext
    }
  }, [_vm._v(_vm._s(_vm.nextPast === 'next' ? 'Past' : 'Next'))])]), _vm._v(" "), _c('div', {
    staticClass: "space-events"
  }, _vm._l((_vm.spaces), function(space) {
    return _c('a', {
      key: space._id,
      attrs: {
        "href": 'https://x.com/i/spaces/' + space.id,
        "target": "_blank"
      }
    }, [_c('h4', [_c('img', {
      attrs: {
        "src": space.creator.profile_image_url
      }
    }), _vm._v(" " + _vm._s(space.creator.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(space.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.formatDate(space.scheduled_start_at)))])])
  }), 0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('a', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    attrs: {
      "href": "https://calendar.google.com/calendar/embed?src=ab4b8a40f14e89db94afb2cbaf4fbef2476606632ba430555522f35c1380374a%40group.calendar.google.com&ctz=America%2FLos_Angeles",
      "target": "_blank"
    }
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-icon btn-block btn-primary my-3",
    attrs: {
      "href": "https://t.me/based_spaces",
      "target": "_blank"
    }
  }, [_vm._v("Telegram Alerts")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-094e2f22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spaces.vue
// module id = PD8U
// module chunks = 2